module.exports = __webpack_public_path__ + "static/img/3.e7b3212c.png";